module.exports = __webpack_public_path__ + "media/img/logo-transparent-sm-dark-bare-4c42a0a3af0ff9332c3954bc9a7335d5.png";